export default __webpack_public_path__ + "static/media/aboutimg7_low.6abd370a.png";